/**

SHOPIFY FLOW TAGGING:
 
{% assign tags = "" %}
{% for lineItem in order.lineItems %}
  {% for customAttribute in lineItem.customAttributes %}
    {% if customAttribute.key == "Selection" or 
      customAttribute.key == "Delivery Date" or 
      customAttribute.key == "Pick Up" or 
      customAttribute.key == "Delivery Timeslot Weekday" or 
      customAttribute.key == "Delivery Timeslot Weekend" or 
      customAttribute.key == "Delivery Timeslot Seasonal" or 
      customAttribute.key == "Pickup Timeslot Weekday" or 
      customAttribute.key == "Pickup Timeslot Weekend" %}
      {% assign tag = customAttribute.value | strip | truncate: 40, "" %}
      {% unless tags contains tag %}
        {% assign tags = tags | append: tag | append: "," %}
      {% endunless %}
    {% endif %}
  {% endfor %}
  {% if lineItem.lineItemGroup.customAttributes %}
    {% for customAttribute in lineItem.lineItemGroup.customAttributes %}
      {% if customAttribute.key == "Selection" or 
        customAttribute.key == "Delivery Date" or 
        customAttribute.key == "Pick Up" or 
        customAttribute.key == "Delivery Timeslot Weekday" or 
        customAttribute.key == "Delivery Timeslot Weekend" or 
        customAttribute.key == "Delivery Timeslot Seasonal" or 
        customAttribute.key == "Pickup Timeslot Weekday" or 
        customAttribute.key == "Pickup Timeslot Weekend" %}
        {% assign tag = customAttribute.value | strip | truncate: 40, "" %}
        {% unless tags contains tag %}
          {% assign tags = tags | append: tag | append: "," %}
        {% endunless %}
      {% endif %}
    {% endfor %}
  {% endif %}
{% endfor %}
{{ tags | split: "," | uniq | join: ", " }}

*/

/**
 * Custom timeslot script for disbling time selections based on current time, delivery type, and selected date. 
 */



(function() {

  var PEAK_CONFIG = {
    valentinesDay: {
      before: 2,
      after: 2
    },
    mothersDay: {
      before: 3,
      after: 1
    }, 
    salesDay: {
      before: 0,
      after: 5
    }
    
  };

  var CUTOFF_CONFIG = {
    deliveryWeekday: [
      { cutoffHour: 08, cutoffMinute: 30 },
      { cutoffHour: 12, cutoffMinute: 30 },
      { cutoffHour: 16, cutoffMinute: 30 }
    ],
    deliveryWeekend: [
      { cutoffHour: 08, cutoffMinute: 30 },
      { cutoffHour: 12, cutoffMinute: 30 }
    ],
    pickupWeekday: [
      { cutoffHour: 08, cutoffMinute: 30 },
      { cutoffHour: 14, cutoffMinute: 30 },
      { cutoffHour: 16, cutoffMinute: 30 },
      { cutoffHour: 16, cutoffMinute: 30 }
    ],
    pickupWeekend: [
      { cutoffHour: 12, cutoffMinute: 30 },
      { cutoffHour: 12, cutoffMinute: 30 },
      { cutoffHour: 12, cutoffMinute: 30 },
      { cutoffHour: 12, cutoffMinute: 30 }
    ]
  };

  var TIMEZONE = 8; // +8 GMT

  var TIMESLOTS = {

    init: function() {
      TIMESLOTS.actions.setToday();
      TIMESLOTS.events();
    },

    selectors: {
      weekdayHiddenInput: '[data-child-name="hidden-weekday"] input',
      peakSeasonHiddenInput: '[data-child-name="hidden-peak-season"] input',
      errorHiddenInput: '[data-child-name="hidden-error"] input',
      timeslotOptions: '[data-child-type="select"] option',
      deliveryWeekdayTimeslotOptions: 'select[name="properties[Delivery Timeslot Weekday]"] option',
      deliveryWeekendTimeslotOptions: 'select[name="properties[Delivery Timeslot Weekend]"] option',
      pickupWeekdayTimeslotOptions: 'select[name="properties[Pickup Timeslot Weekday]"] option',
      pickupWeekendTimeslotOptions: 'select[name="properties[Pickup Timeslot Weekend]"] option'
    },

    state: {
      today: new Date(),
      isToday: false,
      isDelivery: true,
      isWeekday: true,
      isPeakSeason: false,
    },

    events: function() {
      document.addEventListener('giftship.datepicker.updated', TIMESLOTS.handlers.handleDatepickerUpdated);
    },

    handlers: {

      handleDatepickerUpdated: function(event) {

        // Update state
        TIMESLOTS.actions.setIsDelivery(event.detail.element);
        TIMESLOTS.actions.setIsToday(event.detail.dateStr);
        TIMESLOTS.actions.setIsWeekday(event.detail.dateStr);
        TIMESLOTS.actions.setIsPeakSeason(event.detail.dateStr);

        // Update DOM
        TIMESLOTS.actions.populateWeekdayHiddenInput();
        TIMESLOTS.actions.populatePeakSeasonHiddenInput();
        TIMESLOTS.actions.conditionallyDisableTimeslots();

      }
      
    },

    actions: {

      enableAllTimeslots: function() {

        var timeslotOptions = document.querySelectorAll(TIMESLOTS.selectors.timeslotOptions);

        timeslotOptions.forEach(function(optionEl) {
          optionEl.disabled = false;
        });

        TIMESLOTS.actions.populateErrorHiddenInput(false);
        
      },

      toggleTimeslots: function(timeslotOptions, cutoffConfig) {

        var allDisabled = true;

        timeslotOptions.forEach(function(optionEl, index) {
          if (index === 0) return; // first option is disabled text

          var shouldDisable = (cutoffConfig[index - 1] && TIMESLOTS.actions.isPastCutoffTime(cutoffConfig[index - 1]));
          optionEl.disabled = shouldDisable;

          if (!shouldDisable) {
            allDisabled = false;
          }
        });

        TIMESLOTS.actions.populateErrorHiddenInput(allDisabled);

      },

      isPastCutoffTime: function(config) {

        if (typeof config?.cutoffHour === "undefined" || typeof config?.cutoffMinute === "undefined") {
          console.warn("Invalid timeslot cutoff config.");
          return false;
        }

        var currentHour = TIMESLOTS.state.today.getUTCHours();
        var currentMinute = TIMESLOTS.state.today.getUTCMinutes();
    
        return (currentHour > config.cutoffHour || (currentHour === config.cutoffHour && currentMinute > config.cutoffMinute));
        
      },

      conditionallyDisableTimeslots: function() {

        if (!TIMESLOTS.state.isToday) {
          TIMESLOTS.actions.enableAllTimeslots();
          return;
        }

        var timeslotOptions = [];
        var cutoffConfig = [];

        if (TIMESLOTS.state.isDelivery && TIMESLOTS.state.isWeekday) {

          timeslotOptions = document.querySelectorAll(TIMESLOTS.selectors.deliveryWeekdayTimeslotOptions);
          cutoffConfig = CUTOFF_CONFIG.deliveryWeekday;
          
        } else if (TIMESLOTS.state.isDelivery && !TIMESLOTS.state.isWeekday) {

          timeslotOptions = document.querySelectorAll(TIMESLOTS.selectors.deliveryWeekendTimeslotOptions);
          cutoffConfig = CUTOFF_CONFIG.deliveryWeekend;
          
        } else if (!TIMESLOTS.state.isDelivery && TIMESLOTS.state.isWeekday) {

          timeslotOptions = document.querySelectorAll(TIMESLOTS.selectors.pickupWeekdayTimeslotOptions);
          cutoffConfig = CUTOFF_CONFIG.pickupWeekday;
          
        } else {

          timeslotOptions = document.querySelectorAll(TIMESLOTS.selectors.pickupWeekendTimeslotOptions);
          cutoffConfig = CUTOFF_CONFIG.pickupWeekend;
          
        }
        
        TIMESLOTS.actions.toggleTimeslots(timeslotOptions, cutoffConfig);
        
      },

      populateErrorHiddenInput: function(isError) {

        var errorHiddenInputEl = document.querySelector(TIMESLOTS.selectors.errorHiddenInput);

        if (!errorHiddenInputEl) {
          console.warn("Could not find error hidden input.");
          return;
        }

        errorHiddenInputEl.value = (isError) ? "true" : "false";
        
      },

      populateWeekdayHiddenInput: function() {

        var weekdayHiddenInputEl = document.querySelector(TIMESLOTS.selectors.weekdayHiddenInput);

        if (!weekdayHiddenInputEl) {
          console.warn("Could not find day of weekday hidden input.");
          return;
        }

        weekdayHiddenInputEl.value = (TIMESLOTS.state.isWeekday) ? "true" : "false";
        
      },

      populatePeakSeasonHiddenInput: function() {

        var peakSeasonHiddenInputEl = document.querySelector(TIMESLOTS.selectors.peakSeasonHiddenInput);

        if (!peakSeasonHiddenInputEl) {
          console.warn("Could not find day of peak season hidden input.");
          return;
        }

        peakSeasonHiddenInputEl.value = (TIMESLOTS.state.isPeakSeason) ? "true" : "false";
        
      },

      getMothersDayDateStr: function(year) {

        var mayFirst = TIMESLOTS.actions.getGMT8Date(`${year}-05-01`);
        var dayOfWeek = mayFirst.getDay();
        var offset = (7 - dayOfWeek + 7) % 7;
        var secondSunday = 1 + offset + 7;
        var secondSundayStr = (secondSunday < 10) ? `0${secondSunday}` : secondSunday.toString();

        return `${year}-05-${secondSundayStr}`;
        
      },

      isMothersDayPeak: function(date, year) {

        var mothersDayDateStr = TIMESLOTS.actions.getMothersDayDateStr(year);

        var mothersStart = new Date(mothersDayDateStr);
        mothersStart.setDate(mothersStart.getDate() - PEAK_CONFIG.mothersDay.before);

        var mothersEnd = new Date(mothersDayDateStr);
        mothersEnd.setDate(mothersEnd.getDate() + PEAK_CONFIG.mothersDay.after);

        return (date >= mothersStart && date <= mothersEnd);
        
      },

      isValentinesDayPeak: function(date, year) {

        var valentinesDateStr = `${year}-02-14`;

        var valentinesStart = new Date(valentinesDateStr);
        valentinesStart.setDate(valentinesStart.getDate() - PEAK_CONFIG.valentinesDay.before);

        var valentinesEnd = new Date(valentinesDateStr);
        valentinesEnd.setDate(valentinesEnd.getDate() + PEAK_CONFIG.valentinesDay.after);

        console.log("valentinesStart", valentinesStart);
        console.log("valentinesEnd", valentinesEnd);

        return (date >= valentinesStart && date <= valentinesEnd);
        
      },

      setIsPeakSeason: function(dateStr) {

        if (!TIMESLOTS.state.isDelivery) {
          TIMESLOTS.state.isPeakSeason = false;
        }

        var date = TIMESLOTS.actions.getGMT8Date(dateStr);
        var year = date.getFullYear();
      
        var isValentinesPeak = TIMESLOTS.actions.isValentinesDayPeak(date, year); 
        var isMothersDayPeak = TIMESLOTS.actions.isMothersDayPeak(date, year);
      
        TIMESLOTS.state.isPeakSeason = isValentinesPeak || isMothersDayPeak;

      },

      setIsDelivery: function(datepickerEl) {

        TIMESLOTS.state.isDelivery = Boolean(datepickerEl && datepickerEl.getAttribute("name") === "properties[Delivery Date]");
        
      },

      setIsWeekday: function(dateStr) {

  

        if (!dateStr || typeof dateStr !== "string") {
          console.warn("Invalid date selected.");
          return;
        }

        var gmt8Time = TIMESLOTS.actions.getGMT8Date(dateStr);
        var dayOfWeek = gmt8Time.getUTCDay();

        /** uncomment to unlock and set public holiday  

        const isoDate = gmt8Time.toISOString();
        const isSpecialHoliday = PUBLIC_HOLIDAYS.some(date => isoDate.startsWith(date));
        TIMESLOTS.state.isWeekday = (!isSpecialHoliday && dayOfWeek !== 0 && dayOfWeek !== 6); */

        /** uncomment to unlock and set public holiday - hardcoded */
        const isoDate = gmt8Time.toISOString();
        const specialDates = [
              "2026-01-01", // New Year’s Day 
              "2026-02-16", // Chinese New Year eve
              "2026-02-17", // Chinese New Year Day 1 
              "2026-02-18", // Chinese New Year Day 2 
              "2026-03-21", // Hari Raya Puasa (subject to confirmation)
              "2026-04-03", // Good Friday 
              "2026-05-01", // Labour Day 
              "2026-05-27", // Hari Raya Haji 
              "2026-05-31", // Vesak Day (falls on Sunday) 
              "2026-06-01", // Replacement Monday for Vesak Day (since 31 May is Sunday) 
              "2026-08-09", // National Day 
              "2026-08-10", // Replacement Monday for National Day (since 9 Aug is Sunday) 
              "2026-11-08", // Deepavali 
              "2026-11-09", // Replacement Monday for Deepavali (since 8 Nov is Sunday) 
              "2026-12-25",  // Christmas Day 
//2027
  "2027-01-01", // Friday - New Year's Day
  "2027-02-05", // *KIV Friday - Chinese New Year Eve 
  "2027-02-06", // Saturday - Chinese New Year (Day 1)
  "2027-02-07", // Sunday - Chinese New Year (Day 2)
  "2027-02-08", // Monday - Replacement Monday for Chinese New Year
  "2027-03-10", // Wednesday - Hari Raya Puasa
  "2027-03-26", // Friday - Good Friday
  "2027-05-01", // Saturday - Labour Day
  "2027-05-17", // Monday - Hari Raya Haji
  "2027-05-20", // Thursday - Vesak Day
  "2027-08-09", // Monday - National Day
  "2027-10-28", // Thursday - Deepavali
  "2027-12-25"  // Saturday - Christmas Day

        ];

        const isSpecialHoliday = specialDates.some(date => isoDate.startsWith(date));
        TIMESLOTS.state.isWeekday = (!isSpecialHoliday && dayOfWeek !== 0 && dayOfWeek !== 6);
      

        /** uncomment to set to original */
        /*TIMESLOTS.state.isWeekday = (dayOfWeek !== 0 && dayOfWeek !== 6);*/
        
        
      },

      setIsToday: function(dateStr) {

        if (!dateStr || typeof dateStr !== "string") {
          console.warn("Invalid date selected.");
          return;
        }

        var [year, month, day] = dateStr.split("-").map(Number);
        var today = TIMESLOTS.state.today;

        TIMESLOTS.state.isToday = (
          year === today.getUTCFullYear() &&
          month === today.getUTCMonth() + 1 &&
          day === today.getUTCDate()
        );

      },

      setToday: function() {
    
        TIMESLOTS.state.today = TIMESLOTS.actions.getGMT8Date();
        
      },

      getGMT8Date: function(dateStr = null) {

        var date = (dateStr) ? new Date(dateStr) : new Date();
        return new Date(date.getTime() + (TIMEZONE * 60 * 60 * 1000));
    
      }
      
    }
    
  };

  TIMESLOTS.init();
  
})();
